(function () {
    'use strict';

    function phaseInformationPartConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/phaseInformationPartConfiguration.html',
            link: function (scope) {
            }
        };
    }

    phaseInformationPartConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('phaseInformationPartConfiguration', phaseInformationPartConfiguration);
})();

